import { createApp } from "vue"
import Search from "./SearchOverview.vue"

const app = createApp(Search)
app.mount("#search")
